import { cx, styled } from "simplydo/react/styled";

export const StyledTabPane = styled.div<{ $active?: boolean }>`
  display: ${({ $active }) => ($active === false ? "none" : "block")};
  margin-top: 1em;
  position: relative;

  &.is-loading {
    min-height: 4em;
  }

  &.is-loading::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
  }

  &.is-loading::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1.5em;
    height: 1.5em;
    margin: -0.75em 0 0 -0.75em;
    border: 0.2em solid rgba(0, 0, 0, 0.1);
    border-top-color: #767676;
    border-radius: 50%;
    animation: sdo-tab-spin 0.6s linear infinite;
    z-index: 2;
  }

  @keyframes sdo-tab-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const StyledTab = styled.div`
  font-family: inherit;

  ${StyledTabPane} {
    background: #fff;
    padding: 1rem;
    margin: 0;
    border-radius: 0 0 4px 4px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-top: none;
  }
`;

export function tabPaneClassName(
  className: string | undefined,
  loading?: boolean,
): string {
  return cx(loading && "is-loading", className);
}
